import {
  ApplicationConfig,
  importProvidersFrom,
  provideZoneChangeDetection,
} from "@angular/core";
import { provideRouter } from "@angular/router";

import { routes } from "./app.routes";
import { HttpClient, provideHttpClient, withInterceptors } from "@angular/common/http";
import { initializeApp, provideFirebaseApp } from "@angular/fire/app";
import { provideAuth, getAuth } from "@angular/fire/auth";
import { provideFirestore, getFirestore } from "@angular/fire/firestore";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateUniversalLoader } from "./translate-universal-loader";
import { provideMatomo, withRouteData, withRouter } from "ngx-matomo-client";
import { provideAnimations } from "@angular/platform-browser/animations";

import { environment } from "../../../commondata/environments/environment";
import { MAT_DATE_LOCALE } from "@angular/material/core";
import { tokenInterceptorFn } from "./core/http/token.interceptor";

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimations(),
    provideHttpClient(withInterceptors([tokenInterceptorFn])),
    provideFirebaseApp(() => initializeApp(environment.configFirebase)),
    provideFirestore(() => getFirestore()),
    provideAuth(() => getAuth()),
    [{ provide: MAT_DATE_LOCALE, useValue: "it-IT" }],
    provideMatomo(
      { trackerUrl: "https://matomo.anastasis.it/", siteId: (environment.production ? "4" : "7") },
      withRouter(),
      withRouteData()
    ),
    importProvidersFrom([
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useClass: TranslateUniversalLoader,
          deps: [HttpClient],
        },
      }),
    ]),
  ],
};
